import { __ } from '@wordpress/i18n';

import { ToolbarGroup, ToolbarButton } from '@wordpress/components';

import editIcon from 'blockbite-icons/dist/Pencil1';
import { Icon } from '@components/ui/Icon';

const BlockbiteControls = () => {
  return (
    <>
      <ToolbarGroup>
        <ToolbarButton
          icon={<Icon icon={editIcon} />}
          label="Edit"
          onClick={() => console.log('test')}
        />
      </ToolbarGroup>
    </>
  );
};

export default BlockbiteControls;
